import { memo } from 'react';
import FilterSlideoutSection from '../FilterSlideoutSection.jsx';
import { clearSection, getSectionActiveCount, joinClasses } from '../filterSlideout.utils.js';

function RadioDot({ checked }) {
  return (
    <span
      className={joinClasses(
        'inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border bg-white p-[3px]',
        checked ? 'border-[#2173FF]' : 'border-[#5C5C5C]',
      )}
      aria-hidden
    >
      {checked ? <span className="h-full w-full rounded-full bg-[#2173FF]" /> : null}
    </span>
  );
}

const TitleSection = ({ section }) => {
  const activeCount = getSectionActiveCount(section);
  const options = section.options ?? [];

  const handleSelect = (option) => {
    if (option.disabled || section.disabled) return;
    const next =
      section.value === option.value && section.allValue !== undefined
        ? section.allValue
        : option.value;
    section.onChange?.(next);
  };

  return (
    <FilterSlideoutSection
      title={section.title}
      defaultExpanded={section.defaultExpanded ?? true}
      disabled={section.disabled}
      activeCount={activeCount}
      onClear={() => clearSection(section)}
    >
      <div className="flex flex-wrap gap-3">
        {options.map((option) => {
          const checked = section.value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={checked}
              disabled={section.disabled || option.disabled}
              onClick={() => handleSelect(option)}
              className={joinClasses(
                'flex h-8 items-center gap-2 rounded px-1 text-xs font-medium text-content-secondary',
                'transition-colors hover:bg-surface-hover',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
                section.disabled || option.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
              )}
            >
              <RadioDot checked={checked} />
              <span className="whitespace-nowrap">{option.label}</span>
            </button>
          );
        })}
      </div>
    </FilterSlideoutSection>
  );
};

export default memo(TitleSection);
